package diana.soleil.design.iraniancanadienbazzar.core.data

import diana.soleil.design.iraniancanadienbazzar.core.common.AppPreferences
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * Holds the set of **saved (favorited) business ids** as observable state, **persisted** via
 * [AppPreferences] so favorites survive restarts. Detail/list screens observe it to render the saved
 * state and toggle it. Lives in `:core:data` so features stay decoupled from storage. Signed-in
 * accounts merge with and mirror to `users/{uid}.savedBusinessIds` via `UserPreferencesSync`
 * (`:shared`); guests stay device-local.
 */
class FavoritesController(private val preferences: AppPreferences) {
    private val _favorites = MutableStateFlow(preferences.favoriteBusinessIds)
    val favorites: StateFlow<Set<String>> = _favorites.asStateFlow()

    fun isFavorite(businessId: String): Boolean = businessId in _favorites.value

    /** Add the id if absent, remove it if present; persists and emits the new set. */
    fun toggle(businessId: String) {
        if (businessId.isBlank()) return
        val next = _favorites.value.toMutableSet().apply { if (!add(businessId)) remove(businessId) }
        preferences.favoriteBusinessIds = next
        _favorites.value = next
    }

    /** Replaces the whole set (sign-in merge with the account's saved ids); persists and emits. */
    fun replaceAll(ids: Set<String>) {
        preferences.favoriteBusinessIds = ids
        _favorites.value = ids
    }
}
